/* Get client id */
export function getCID() {
	let match = document.cookie.match('(?:^|;)\\s*_ga=([^;]*)');
	const raw = (match) ? decodeURIComponent(match[1]) : null;
	if (raw) {
		match = raw.match(/(\d+\.\d+)$/);
	}
	const gacid = (match) ? match[1] : null;
	if (gacid) {
		return gacid;
	}
}

/* Declension of words by number */
export function declension(number, titles) {
	const cases = [2, 0, 1, 1, 1, 2];
	return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5]];
}

/* Debounce Function in order to limit function calls  */
export function debounce(func, delay) {
	let timerId;

	return function (...args) {
		clearTimeout(timerId);
		timerId = setTimeout(() => {
			func.apply(this, args);
		}, delay);
	};
}

/* Throttle Function in order to limit function calls  */
export function throttle(func, delay) {
	let lastCall = 0;

	return function (...args) {
		const now = Date.now();

		if (now - lastCall >= delay) {
			lastCall = now;
			func.apply(this, args);
		}
	};
}

/* Create Element */
export function createElement(options) {
	const { name, className, id, child, children, content, html, dataAttr, attr } = options;
	const elem = document.createElement(name);
	if (id) elem.id = id;
	if (className) elem.className = className;
	if (content) elem.textContent = content;
	if (html) elem.innerHTML = html;
	if (child) elem.appendChild(child);
	if (children) children.forEach(child => elem.appendChild(child));
	if (dataAttr) elem.setAttribute('data-' + dataAttr[0], dataAttr[1]); // dataAttr = [name, value]; name = string, value = any.
	if (attr) {
		if (Array.isArray(attr)) {
			attr.forEach(item => elem.setAttribute(item.name, item.value));
		} else {
			if (attr.hasOwnProperty('name') && attr.hasOwnProperty('value')) {
				elem.setAttribute(attr.name, attr.value);
			}
		}
	}

	return elem;
}

/* Check element exists */
export function securityGate(value) {
	return (typeof value !== 'undefined') && (value !== null) && (!!value !== false);
}

/* Get custom radio-button field */
export function getRadioFieldTemplate(text, group) {
	const nameAttr = group ? ' name=\"group\"' : '';

	return (
		`<label class="radio">
			<input class="radio_input" type="radio"${nameAttr}>
			<span class="radio_checkmark"></span>
			<p class="radio_label">${text}</p>
		</label>`
	);
}

/* Get custom checkbox field */
export function getCheckboxFieldTemplate(text) {
	return (
		`<label class="checkbox">
			<input class="checkbox_input" type="checkbox">
			<span class="checkbox_checkmark"></span>
			<p class="checkbox_label">${text}</p>
		</label>`
	);
}

/* Create chip (custom radio) input */
export function createChipInput({ name, label, value }) {
	return (`
		<label class="chip">
			<input type="radio" class="chip_input" name="${name}" value="${value}">
			<span class="chip_checkmark">${label}</span>
		</label>
	`);
}

/* Convert days to seconds */
export function daysToSec(num) {
	return num * 24 * 60 * 60;
}

/* Get time string by provided timestamp and delimiter */
export function getTimeByTimestamp(timestamp, delimiter = ':') {
	const date = new Date(timestamp);
	const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
	const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
	const seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
	return `${hours}${delimiter}${minutes}${delimiter}${seconds}`;
}

export function removeHash () {
	history.replaceState("", document.title, window.location.pathname
		+ window.location.search);
}

/* Animation Functions */

export function animate({timing, draw, duration, beforeStart, afterEnd}) {
	let start = performance.now();

	if (beforeStart) beforeStart();

	requestAnimationFrame(function animate(time) {
		let timeFraction = (time - start) / duration;

		if (timeFraction > 1) {
			timeFraction = 1;

			if (afterEnd) afterEnd();
		}

		let progress = timing(timeFraction);

		draw(progress);

		if (timeFraction < 1) {
			requestAnimationFrame(animate);
		}
	});
}

export function easeInOutCubic(t) {
	return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1;
}

export function fadeIn({$el, timing, duration, displayType}) {
	timing = timing || easeInOutCubic;
	duration = duration || 300;
	displayType = displayType || 'block';

	animate({
		timing,
		duration,
		draw: progress => {
			$el.style.opacity = progress;
		},
		beforeStart: () => {
			$el.style.display = displayType;
		}
	});
}

export function fadeOut({$el, timing, duration}) {
	timing = timing || easeInOutCubic;
	duration = duration || 300;

	animate({
		timing,
		duration,
		draw: progress => {
			$el.style.opacity = 1 - progress;
		},
		afterEnd: () => {
			$el.style.display = 'none';
		}
	});
}

export function animatedScroll($element, distance) {
	let passed = 0;
	const step = 20;

	const timer = setInterval(() => {

		if (passed >= distance) {

			clearInterval(timer);

		}

		$element.scrollBy(0, step);

		passed += step;

	}, step);
}

export function compareMaps(map1, map2) {
	let testVal;

	if (map1.size !== map2.size) {
		return false;
	}
	for (let [key, val] of map1) {
		testVal = map2.get(key);
		// in cases of an undefined value, make sure the key
		// actually exists on the object so there are no false positives
		if (testVal !== val || (testVal === undefined && !map2.has(key))) {
			return false;
		}
	}
	return true;
}

/* Coordinates */
export function getElementTopPosition($el) {
	return $el.getBoundingClientRect().top + pageYOffset;
}

/* Array functions */
/**
 * Gets max number of array
 * @param arr: Array -> Array of numbers only!
 **/
export function arrMaxNum(arr) {
	return Math.max.apply(null, arr);
}

/**
 * Gets min number of array
 * @param arr: Array -> Array of numbers only!
 **/
export function arrMinNum(arr) {
	return Math.min.apply(null, arr);
}

export function randomIntFromInterval(min, max) { // min and max included
	return Math.floor(Math.random() * (max - min + 1) + min);
}


export function randomIntFromIntervalWithStep(min, max, step = 1) {
	return min + Math.floor(Math.random() * ((max - min) / step + 1)) * step;
}